export default "__VITE_ASSET__B7DWX6kb__"